<template>
  <WhatHappening />

  <div class="row g-4">

  <!-- Ligne 1 : Courses + Event -->
  <!-- <div class="col-xxl-4">
    <FundamentalCourses />
  </div>
  <div class="col-xxl-8">
    <TodaysEvent />
  </div> -->


  <!-- Ligne 2 : Stats — leur propre row imbriquée -->
  <div class="col-12">
    <div class="pb-2">
    <h4> Tableau de Bord</h4>
  </div>
    <div class="row row-cols-1 row-cols-md-3 row-cols-xxl-5 g-3">

      <div class="col">
        <div class="stat-card card border-0 rounded-3 overflow-hidden">
          <div class="p-4 d-flex align-items-center gap-3">
            <div class="stat-icon-wrapper bg-success rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
              <i class="bi bi-newspaper text-white fs-4"></i>
            </div>
            <div>
              <p class="stat-label mb-0">Actualités</p>
              <h3 class="stat-value mb-0">{{ statistiques.actualites }}</h3>
            </div>
          </div>
          <div class="stat-card-bar bg-success"></div>
        </div>
      </div>


      

      <div class="col">
        <div class="stat-card card border-0 rounded-3 overflow-hidden">
          <div class="p-4 d-flex align-items-center gap-3">
            <div class="stat-icon-wrapper bg-danger rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
              <i class="bi bi-camera-video text-white fs-4"></i>
            </div>
            <div>
              <p class="stat-label mb-0">Vidéothèque</p>
              <h3 class="stat-value mb-0">{{ statistiques.videos }}</h3>
            </div>
          </div>
          <div class="stat-card-bar bg-danger"></div>
        </div>
      </div>

      <div class="col">
        <div class="stat-card card border-0 rounded-3 overflow-hidden">
          <div class="p-4 d-flex align-items-center gap-3">
            <div class="stat-icon-wrapper bg-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
              <i class="bi bi-images text-white fs-4"></i>
            </div>
            <div>
              <p class="stat-label mb-0">Photothèque</p>
              <h3 class="stat-value mb-0">{{ statistiques.photos }}</h3>
            </div>
          </div>
          <div class="stat-card-bar bg-primary"></div>
        </div>
      </div>

      <div class="col">
        <div class="stat-card card border-0 rounded-3 overflow-hidden">
          <div class="p-4 d-flex align-items-center gap-3">
            <div class="stat-icon-wrapper bg-dark rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
             <i class="bi bi-gear-fill fs-3" style="color: white;"></i>
            </div>
            <div>
              <p class="stat-label mb-0">Services</p>
              <h3 class="stat-value mb-0">{{ statistiques.services }}</h3>
            </div>
          </div>
          <div class="stat-card-bar bg-dark"></div>
        </div>
      </div>

      <div class="col">
        <div class="stat-card card border-0 rounded-3 overflow-hidden">
          <div class="p-4 d-flex align-items-center gap-3">
            <div class="stat-icon-wrapper bg-secondary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
             <i class="bi bi-people-fill fs-3" style="color: white;"></i>
            </div>
            <div>
              <p class="stat-label mb-0">Partenaires</p>
              <h3 class="stat-value mb-0">{{ statistiques.partenaires }}</h3>
            </div>
          </div>
          <div class="stat-card-bar bg-secondary"></div>
        </div>
      </div>

      <div class="col">
        <div class="stat-card card border-0 rounded-3 overflow-hidden">
          <div class="p-4 d-flex align-items-center gap-3">
            <div class="stat-icon-wrapper bg-info rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
             <i class="bi bi-diagram-3-fill fs-3" style="color: white;"></i>
            </div>
            <div>
              <p class="stat-label mb-0">Organisations</p>
              <h3 class="stat-value mb-0">{{ statistiques.organisations }}</h3>
            </div>
          </div>
          <div class="stat-card-bar bg-info"></div>
        </div>
      </div>

    </div>
  </div>

  <!-- Ligne 3 : Categories + CoursesClass -->
  <div class="col-xxl-4">
    <CategoriesCourses />
  </div>
  <div class="col-xxl-8">
    <CoursesClass />
  </div>

</div>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import WhatHappening from "../../components/Dashboard/LMSCourses/WhatHappening.vue";
// import TodaysEvent from "../../components/Dashboard/LMSCourses/TodaysEvent.vue";
import CategoriesCourses from "../../components/Dashboard/LMSCourses/CategoriesCourses/index.vue";
import CoursesClass from "../../components/Dashboard/LMSCourses/CoursesClass/index.vue";
// import FundamentalCourses from "../../components/Dashboard/LMSCourses/FundamentalCourses/index.vue";

export default defineComponent({
  name: "LMSCoursesPage",
  components: {
    WhatHappening,
    // TodaysEvent,
    CategoriesCourses,
    CoursesClass,
    // FundamentalCourses,
  },
  setup() {
    const statistiques = ref({
      actualites: 0,
      videos: 0,
      photos: 0,
      services: 0,
      partenaires: 0, 
      organisations: 0,
    });

    onMounted(async () => {
      try {
        const ApiService = (await import("@/services/ApiService")).default;
        const response = await ApiService.get("/dashboard/kpi");
        statistiques.value = response.data.data;
      } catch (error) {
        console.error(error);
      }
    });

    return { statistiques };
  },
});
</script>

<style>
.stat-card {
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.14);
}

.stat-icon-wrapper {
  width: 52px;
  height: 52px;
}

.stat-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #8a94a6;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1f36;
  line-height: 1;
}

.stat-card-bar {
  height: 5px;
  width: 100%;
}
</style>